import React from "react";
import SaleTag from "images/buy-now.svg";
import PriceTag from "images/design-system-svgs/pricetag.svg";
import { useAppSelector } from "../../../../../../util/store-types";

interface SubscriptionPromoBannerProps {
  isLegacyPdp?: boolean;
}

const SubscriptionPromoBanner = ({ isLegacyPdp = false }: SubscriptionPromoBannerProps) => {
  const cmsPromoBanner = useAppSelector(state => state.smartComponentState?.PDPContent?.data?.membership);
  const cmsPromoBannerSkinny = useAppSelector(state => state.smartComponentState?.PDPContent?.data?.membership?.skinny);

  if (isLegacyPdp) {
    if (Object.keys(cmsPromoBanner ?? {})?.length === 0) {
      return null;
    }
    return (
      <div
        className="h-full p-3 rounded-md text-sm bg-lilac border border-lighterGray shadow-[0px_4px_8px_0px_rgba(0,0,0,0.10)]"
        data-test-id="subscription-promo-banner">
        <div className="flex items-center mb-1">
          <SaleTag />
          <p className="ml-2 font-semibold">{cmsPromoBanner?.hed}</p>
        </div>
        <p className="ml-8">{cmsPromoBanner?.copy}</p>
      </div>
    );
  }

  if (!cmsPromoBannerSkinny) {
    return null;
  }

  return (
    <div
      className="flex items-center mb-1 pl-3 pr-4 py-1 rounded-full text-sm bg-darkPink"
      data-test-id="subscription-promo-banner">
      <PriceTag className="shrink-0" />
      <div className="ml-3">
        <p className="whitespace-pre-line">{cmsPromoBannerSkinny}</p>
      </div>
    </div>
  );
};

export default SubscriptionPromoBanner;
